<template>
    <div id="homeBox">
        <div style="display: flex;justify-content: space-between;height: 40px">
            <div style="display:flex;align-items: center">
                <div style="margin-right: 15px;margin-left: 20px;">
                    <el-button  type="text" @click="opencard">开卡</el-button>
                </div>
                <div>
                    <el-button  type="text">解绑</el-button>
                </div>
            </div>
            <div style="display:flex;align-items: center;margin-right: 20px">
                <div style="margin: 0 15px">
                    <el-select  size="mini" v-model="companydata" slot="prepend" placeholder="请选择">
                        <el-option v-for="val in companyList" :key="val.id" :label='val.name' :value="val.name"></el-option>
                    </el-select>
                </div>
                <div>
                    <el-input
                            size="mini"
                            class="input"
                            placeholder="请输入搜索内容"
                            v-model="StatsSearchdata"
                            clearable>
                    </el-input>
                </div>
            </div>
        </div>


        <el-table
                class="el-table-width"
                ref="deliverlight"
                :height="tableHeight"
                highlight-current-row
                :data="tableData"
                border>
            <el-table-column
                    prop="index"
                    :label="$t('form_serial_number')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop=""
                    label="NFC卡号"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop=""
                    label="编号"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    label="用户"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop=""
                    label="余额"
                    show-overflow-tooltip>
            </el-table-column>
<!--            <el-table-column-->
<!--                    prop=""-->
<!--                    label="办卡日期"-->
<!--                    show-overflow-tooltip>-->
<!--            </el-table-column>-->
            <el-table-column
                    prop=""
                    label="状态"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop=""
                    label="录入人"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop=""
                    label="录入时间"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    label="操作"
                    show-overflow-tooltip>
                <template slot-scope="scope">

                </template>
            </el-table-column>
        </el-table>
        <el-dialog
                :close-on-click-modal="false"
                style="display: flex;justify-content: center;align-items: center;color: black;font-weight: bold"
                title="提示"
                :visible.sync="delDialogVisible"
                width="400px"
                top="30px"
                height="300"
                center
                v-if="delDialogVisible"
        >
              <add-card></add-card>
        </el-dialog>
    </div>
</template>

<script>
    import {mapActions} from "vuex";
    import addcard from "./component/addCard";

    import * as API from "./api";
    export default{
        name:'mealCardManage',
        components:{
            addcard
        },
        data(){
            return{
                delDialogVisible:false,
                tableHeight:'',
                tableData:[]
            }
        },

        mounted(){
            this.$nextTick(()=>{
                this.onResize();
            })
        },
        activated(){
            this.onResize();
        },
        watch:{
            '$root.workSize':{
                handler(n,o) {
                    // console.log(n,12312312)
                    this.onResize(n);
                },
                deep:true,
            },
        },
        methods:{
            opencard(){
                this.delDialogVisible=true
            },
            onResize (n){
                if (n==undefined) n=this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-80
            },
            ...mapActions(["getCurrentMenuId"]),
            //高度
            heightAuto(){
                this.$nextTick(()=>{
                    this.tableHeight = window.innerHeight -  document.getElementById('body').getBoundingClientRect().top -90
                })
            },

            //分页
            handleSizeChange(val) {
                this.pageSize = val;    //动态改变
                // this.getList()
            },
            handleCurrentChange(val) {
                this.currentPage = val;    //动态改变
                // this.getList()
            },

        },
    }

</script>
<style lang="scss" scoped>
    .flexcenter{
        min-width: 39.286rem;
        width: 100%;
        height: 2.857rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 0.857rem;
    }
    /deep/{
        .el-table--enable-row-transition{
            /*min-width: 53.571rem !important;*/
        }
        .el-button--text{
            padding: 0 !important;
            margin-left: 0 !important;
            margin-right: 10px;
        }
        .el-tabs__content{
            /*height: 90% !important;*/
            overflow: visible !important;
            height:calc(100% - 0.357rem) !important;
        }
    }
    /deep/.is-leaf .cell .el-checkbox__input{
        display: none;
    }
    .m{
        padding-top: 1.429rem;
    }
    .flexother {
        display: flex;
        /*flex-flow: wrap;*/
        justify-content: space-between;
        align-items: center;
    }
    .fl{
        float: left;
        .el-button--primary{
            color: #efd773;
            background-color:white;
            border: 0;
            text-align: center;
            padding: 0;
            height: 2rem;
            width: 3.286rem;
            margin:0.857rem 0 0 0.714rem;
        }
    }

    .fr{
        float:right;
    }

    .cl{
        clear: both;
    }
    .input{
        width: 14.286rem;
    }
    /*.mrt20{*/
    /*    margin-top: 1.429rem;*/
    /*}*/
    .mrl20{
        margin-left: 1.429rem;
    }
    .mrb20{
        margin-right: 1.429rem;
    }
    .mrr20{
        margin-right: 1.429rem;
    }

    .chooseheader{
        width:100%;
    }

    .choosepage{
        /*min-width: 42.571rem;*/
        width:90%
    }
    .left{
        width: 17.857rem;
    }
</style>